import { KeySearch } from '@/shared/model/filter.model';
import { Module } from 'vuex';

export const navbarStore: Module<any, any> = {
  namespaced: true,
  state: {
    collectionLoaded: false,
    collectionLoading: false,
    // resetCollection: false,
    filterList: [],
    scrapsSelected: [],
    filterSearch: new Array<KeySearch>(),
    isFilterChange: 0,
  },
  getters: {
    isCollectionLoaded: state => state.collectionLoaded,
    isCollectionLoading: state => state.collectionLoading,
    // isResetCollection: state => state.resetCollection,
    getFilterList: state => state.filterList,
    getScrapsSelected: state => state.scrapsSelected,
    getFilterSearch: state => state.filterSearch,
    getIsFilterChange: state => state.isFilterChange,
  },
  mutations: {
    setCollectionLoad(state, newVal) {
      state.collectionLoaded = newVal;
    },
    setCollectionLoading(state, newVal) {
      state.collectionLoading = newVal;
    },
    // setResetCollection(state, newVal) {
    //   state.resetCollection = newVal;
    // },
    setFilterList(state, newVal) {
      state.filterList = newVal;
    },
    setScrapsSelected(state, newVal) {
      state.scrapsSelected = newVal;
    },
    setFilterSearch(state, newVal) {
      state.filterSearch = newVal;
      state.isFilterChange++;
    },
    resetFilterNavbar(state) {
      state.filterSearch = [];
    },
  },
  actions: {
    setCollectionLoadAc(context, payload: { newVal: any }) {
      context.commit('setCollectionLoad', payload.newVal);
    },
    setCollectionLoading(context, payload: { newVal: any }) {
      context.commit('setCollectionLoading', payload.newVal);
    },
    // setResetCollection(context, payload: { newVal: any }) {
    //   context.commit('setResetCollection', payload.newVal);
    // },
    changeFilterList(context, payload: { newVal: [] }) {
      context.commit('setFilterList', payload.newVal);
    },
    changeScrapsSelected(context, payload: { newVal: [] }) {
      context.commit('setScrapsSelected', payload.newVal);
    },
  },
};
